export default "__VITE_ASSET__Dyq4ycmR__"